var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1666 1.6665H5.49992C5.05789 1.6665 4.63397 1.8421 4.32141 2.15466C4.00885 2.46722 3.83325 2.89114 3.83325 3.33317V16.6665C3.83325 17.1085 4.00885 17.5325 4.32141 17.845C4.63397 18.1576 5.05789 18.3332 5.49992 18.3332H15.4999C15.9419 18.3332 16.3659 18.1576 16.6784 17.845C16.991 17.5325 17.1666 17.1085 17.1666 16.6665V6.6665L12.1666 1.6665ZM11.7499 13.3332V15.8332H9.24992V13.3332H7.16659L10.4999 9.99984L13.8333 13.3332H11.7499ZM11.3333 7.49984V2.9165L15.9166 7.49984H11.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.d52d064b9b032af9c79791a7b557270a.svg";
export { ForwardRef as ReactComponent };